import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { CustomReportsService } from '@wealthlane/api-services/wealthlane-report-service';

const usePutUpdateStandardReportDefaultFields = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: () => void
): UseMutationResult<any | undefined, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const newPayload = { ...payload, reportConfigurationId: payload.id };
      return await handleRequest(
        CustomReportsService.putApiReportApiAppCustomReportsStandardReportsByVendor(newPayload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null && response !== false) {
          await queryClient.invalidateQueries('getReportDesignerById');
          toast.success(
            <ToastComponent label='Success' message='Default fields updated successfully.' />
          );
          onSuccess && onSuccess();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutUpdateStandardReportDefaultFields;
